module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_L1-e045cfdacca707986df64f27d787b6ff.png";